export default "__VITE_ASSET__C70Bx19g__"